"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const typesConstants_1 = require("../../constants/typesConstants");
const profileSlice_1 = require("../../features/profile/profileSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const styles_1 = __importDefault(require("../../styles/styles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const button_1 = __importDefault(require("../button/button"));
const spinner_1 = __importDefault(require("../spinner/spinner"));
const changePasswordFormValidationUtils_1 = __importDefault(require("./changePasswordFormValidationUtils"));
const FieldErrorMessageComponent_1 = __importDefault(require("../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const utils_1 = require("../../utils/utils");
const eventConstants_1 = require("../../constants/eventConstants");
const ChangePasswordFormComponent = () => {
    const dispatch = useAppDispatch_1.default();
    const { loadingStatus, errorMessage, errors } = useAppSelector_1.default((state) => ({
        loadingStatus: state.profile.change_password.status,
        errorMessage: state.profile.change_password.errorMessage,
        errors: state.profile.change_password.errors,
    }));
    react_1.useEffect(() => {
        dispatch(profileSlice_1.resetProfileState());
    }, []);
    let message = null;
    if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS) {
        message = react_1.default.createElement(react_native_paper_1.Subheading, { style: styles_1.default.textColorBlack }, `Password changed successfully! `);
    }
    else if (loadingStatus === typesConstants_1.FAILED_STATUS) {
        const tempError = utils_1.getError('non_field_errors', errors) || errorMessage;
        message = tempError ? react_1.default.createElement(react_native_paper_1.Subheading, { style: styles_1.default.textColorRed }, tempError) : null;
    }
    const initialValues = {
        current_password: '',
        new_password: '',
        repeat_new_password: '',
    };
    const onChangePassword = (payload, { resetForm }) => {
        dispatch(profileSlice_1.changePassword(payload)).then(() => {
            resetForm();
        });
    };
    return loadingStatus === typesConstants_1.PENDING_STATUS ? (react_1.default.createElement(spinner_1.default, null)) : (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: (values, actions) => onChangePassword(values, actions), validate: changePasswordFormValidationUtils_1.default }, ({ handleChange, handleSubmit, values }) => (react_1.default.createElement(react_native_1.View, null,
        message,
        react_1.default.createElement(formik_1.ErrorMessage, { name: "current_password", component: FieldErrorMessageComponent_1.default }),
        react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('current_password', errors) }),
        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Current password", onChangeText: handleChange('current_password'), value: values.current_password, left: true, secureTextEntry: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
        react_1.default.createElement(formik_1.ErrorMessage, { name: "new_password", component: FieldErrorMessageComponent_1.default }),
        react_1.default.createElement(react_native_paper_1.TextInput, { label: "New password", onChangeText: handleChange('new_password'), value: values.new_password, left: true, secureTextEntry: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
        react_1.default.createElement(formik_1.ErrorMessage, { name: "repeat_new_password", component: FieldErrorMessageComponent_1.default }),
        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Repeat New password", onChangeText: handleChange('repeat_new_password'), value: values.repeat_new_password, left: true, secureTextEntry: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
        react_1.default.createElement(button_1.default, { onPress: handleSubmit, text: "Change password", fill: true, eventName: eventConstants_1.CHANGE_PASSWORD_BUTTON })))));
};
exports.default = ChangePasswordFormComponent;
